import { render, staticRenderFns } from "./PlayPause.vue?vue&type=template&id=01c5b578&scoped=true"
import script from "./PlayPause.vue?vue&type=script&lang=js"
export * from "./PlayPause.vue?vue&type=script&lang=js"
import style0 from "./PlayPause.vue?vue&type=style&index=0&id=01c5b578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5b578",
  null
  
)

export default component.exports